import styled from "styled-components";
import theme from 'common/theme';

export const DataTableContainer = styled.div<{ autoSize?: number, gridCols?: string; gridRows?: string, gridAreas?: string }>`

  display: grid;

  font-size: 1em;
  position: relative;
  
  .spacer {
    position: absolute;
    width: 20px;
    background: red;
    left: 0;
    top: 0;
    z-index: 4;
  }

  .cell.header {
    position: sticky;
    top: 0;
    z-index: 1;
    
  }

  .is-hidden { 
    background-color: red;
     
  }

 .scroll { 
    position: relative;
    padding-right: 10px;
      .cell.header {
        position: sticky;
        top: 0;
        z-index: 1;
 
      }
      max-height: 300px;
      overflow: auto;

      .scroll {
        position: sticky;
        top: 0;

       
      }
    }

  .grid {
    font-size: .9em;
    display: grid;
    grid-template-areas: ${({gridAreas}) => gridAreas || undefined};
    grid-template-columns: ${({gridCols}) => gridCols || 'auto'};
    grid-auto-rows: minmax(min-content, max-content);
    border-color: ${theme.colors.border.lightest};

    button.cell {
      background: transparent;
      color: ${theme.colors.jbtBlue};
      font-family: inherit;
      font-size: .8em;
    }
      
    .cell {
      padding: .5em;
      border-style: solid;
      border-color: inherit;
      border-width: 0 0 1px 0;
       
      &:not(.header) { font-size: .9em; }

      text-overflow: ellipsis;
      min-height: min-content;
      
      
      &.value {
        font-size: .95em;
      }
      &.header {
        color: ${theme.colors.main};
        font-weight: 600;
        text-transform: Capitalize;
        border-style: solid;
        border-width: 0 0 2px 0;
        text-transform: capitalize;
        border-color: ${theme.colors.border.light};
        border-width: 0 0 2px 0;
        background-color: white;
        cursor: pointer;

        &:hover {
          border-color: ${theme.colors.jbtBlue};
        }
      }
      &.first { text-align: left;}
      &.last { text-align: right; }
      &.is-hovered {
       // background: rgba(0,0,0,.04);
       cursor: pointer;
      }
      
    }

    .grid .cell.is-hovered{
      background: transparent;
    }
    .hidden { display: none; }

    

    .row, .full {
      grid-column: 1 / -1;
      grid-row: 0;
    }

     
   
   
  

   .title {
      display: grid;
      grid-template-columns:  1fr 1fr 1fr 1fr 1fr;
 
      gap: 1em;

      
    }

  
 h3 { margin: 0; padding: 0;}
 .total {
      margin: 1em 0;
      text-align: center;
      border: solid 1px ${theme.colors.border.light};
      justify-content: center;
      align-items: center;


      .cell-title {
        text-transform: Capitalize;
        font-weight: 600;
        color: black;
      }
    }

  .progress-bar-container {
    position: relative;
    width: 100%;
    background: ${theme.colors.bg.lightest};
    border-radius: 3px;
    overflow: hidden;

    .progress-bar {
      width: 100%;
      min-width: 5px;
      height: 1em;
      border-radius: inherit;
      background: ${theme.colors.jbtBlue};
    }

  }

  .progress-label {
    font-weight: 600;
    font-size: .9em;

  }

  }
`